import HelpButton from "../HelpButton";
import SimpleParagraphs from "./commons/SimpleParagraphs";

export default function RoomLightDuringSleepHelpDialog() {
  return (
    <HelpButton dialogTitle="部屋の明かり（就寝中）">
      <SimpleParagraphs
        paragraphs={[
          {
            title: "睡眠への影響",
            content:
              "個人差はありますが、寝ている間は豆電球程度の低い照度の光でも中途覚醒時間を増加させ、睡眠の効率を下げてしまいます。",
          },
          {
            title: "おすすめ",
            content:
              "寝ている間の照明は真っ暗か、目に光が直接入らないような間接照明・フットライト、パートナーが明かりを必要とする場合はアイマスクの活用がおすすめです。\nまた、寝室にはスマートフォンやタブレット端末を持ち込まず、できるだけ暗くして寝ることが良い睡眠に寄与します。",
          },
        ]}
      />
    </HelpButton>
  );
}
